import { Subject } from 'src/app/Models/subject-breakdown-add-edit';
import { VSubject } from 'src/app/Validators/Validators';
import {
  Component, OnInit, Inject, AfterViewInit, Directive, Input, ViewChild,
  ElementRef, OnDestroy, ChangeDetectionStrategy,
  AfterViewChecked, Output, EventEmitter,ChangeDetectorRef,
  SimpleChanges
} from '@angular/core';
import * as $ from 'jquery';
// import { number } from 'ngx-custom-validators/src/app/number/validator';
// import { SubjectManagmentService } from '../../../service/subject-managment.service';
import { ToastrService } from "ngx-toastr";

import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GoogleObj } from 'src/app/Models/Googletranslate';
import { GoogletranslateService } from 'src/app/Services/googletranslate.service';
import { AppOfflineStore } from '../../../app.offlineService';
import { SubjecttreeComponent } from '../../subject-management/subjecttree/subjecttree.component';
import { identifierModuleUrl } from '@angular/compiler';
import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
import{HttpErrorHandlerService} from '../../../Services/config/http-error-handler.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';




@Component({
  selector: 'app-subject-breakdown-add-edit',
  templateUrl: './subject-breakdown-add-edit.component.html',
  styleUrls: ['./subject-breakdown-add-edit.component.css']
})
export class SubjectBreakdownAddEditComponent implements OnInit {


  @Input() enableedit: boolean;
  @Input() subject: any;
  @Input() subjectById: any;
  @Input() Editsubjectflag: Boolean;
  @Input() MajorTopic: any;
  @Input() Addnewsubject: boolean;
  @Input() Breadcrumblist: any;
   @Input() Addform: FormGroup;
  @Input() subjectcode: any;
  @Input() hideStatus: boolean;
  @Input() Reload: boolean;
   @Input() ngSelect: any;
   @Input() ngSelect1: any;
   @Input() EditedForm: boolean;
  @Input() statusvalidate: string;
  @Input() Refresh: any;
  // @Input() save_submitted:any;
  @Input() ResourceAssignEnabled: boolean;
   @Input() RedirectAssignedresourceId: Number;
  @Input() Disbletranslation:boolean;
   @Input() bracketscheckbox:boolean;
   @Input() Descriptionvalue:any;
   @Output() reset1: EventEmitter<any> = new EventEmitter<any>();
//@Output() Conformationpopup: EventEmitter<any> = new EventEmitter<any>();
   @Output() getsubjectId: EventEmitter<any> = new EventEmitter<any>();
   @Output() edit: EventEmitter<any> = new EventEmitter<any>();
   @Output() getsubjectDataRefresh: EventEmitter<any> = new EventEmitter<any>();
   @Output() Addresource: EventEmitter<any> = new EventEmitter<any>();
  InsertSubject: Subject;
  TreeNodeRefresh: any;
  subjecttranslationbrackets:boolean=false;
  subjectnamechange:boolean=false;
  getcodedescription:any;
  tempvariable:boolean=false;
  reversename:boolean=false;





  constructor(
    private cdr: ChangeDetectorRef,
    public google: GoogletranslateService,
    public ser:SubjectManagmentService,
    private fb: FormBuilder,
    public subjecttree:SubjecttreeComponent,
    private appserv:AppOfflineStore,
    private toastr: ToastrService,
    public Activeroute: ActivatedRoute) {

   }



  ngOnInit() {

    this.getCode();

    //this.cdr.detectChanges();

  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {

    this.Addform.get('Subject_Name')!
    .valueChanges
    .pipe(debounceTime(800), distinctUntilChanged())
    .subscribe(() => {
      this.NameValidation();      // your existing function
      this.Editformvalidation();  // your existing function
    });
  }

//   ngAfterViewInit() {
//     this.getCode();


//     console.log(this.ngSelect);
//     console.log(this.statusvalidate,'statusvalidate');
//     console.log(this.subjectcode,'subjectcode');
//     console.log(this.subjecttree,'subjecttree');



// }

  //subjectcode:any;
  getstatuscode1()
  {
    this.ser.getstatuscode().subscribe((result) => {
      this.subjectcode=result;
      this.ngSelect=this.subjectcode[0].Subject_Status_Type_Code;
      this.ngSelect1=null;
    }, (error:any) => { console.log(error) }
    );

  }

  checkboxvalidate(){
    if(this.subjectById.Language_Type_Code!=null&&this.subjectById.Language_Type_Code!=''&&this.subjectById.Language_Type_Code!=undefined){
    if(this.EditedForm){
      if(this.Addform.controls['Translated_Subject_Name'].value!=null){
      if(!this.subjectnamechange){

      this.Disbletranslation=true;
      this.subjecttranslationbrackets=true;
      this.translate=true;
      this.translatesubjectname();
       if(this.translate){
        if(this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].value==null){
          this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].setValue(this.subjectcode[0].Subject_Status_Type_Code);
        }
      }
    }
      }
      else{
        this.translate=false;
      }

    }
  }
  }

  Editformvalidation()
  {

    this.SubjectNamecount();
    this.Translationcount();
    this.Descriptioncount();
    if(this.Addform.valid){
    var Subject_Name = this.Addform.controls['Subject_Name'].value;
    var Subject_Status_Type_Code = this.Addform.controls['Subject_Status_Type_Code'].value;
    var Description_text = this.Addform.controls['Description_text'].value;
    var Translated_Subject_Name = this.Addform.controls['Translated_Subject_Name'].value;
    var Translated_Subject_Subject_Status_Type_Code = this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].value;
    if(Subject_Name!=this.subjectById.Subject_Name)
    this.tempvariable=true;
    else if(Subject_Status_Type_Code!=this.subjectById.Subject_Status_Type_Code)
    this.tempvariable=true;
    else if(Description_text!=this.subjectById.Description_text)
    this.tempvariable=true;
    else if(Translated_Subject_Name!=this.subjectById.Translated_Subject_Name)
    this.tempvariable=true;
    else if(Translated_Subject_Subject_Status_Type_Code!=this.subjectById.Translated_Subject_Subject_Status_Type_Code)
    this.tempvariable=true;
    else if(Translated_Subject_Subject_Status_Type_Code==null)
    this.tempvariable=false;
    else
    this.tempvariable=false;

  }

  }

  data: any;
  SubjectExistsInd: any;
  namevalidate:boolean=false;



mouseNameValidation(){
  if(this.translate){
    if(this.EditedForm){
    if(this.subjectById.Language_Ind=='N'){
      if(!this.Disbletranslation){
      this.translatesubjectname();
      }
    }
  }
  }
}

onSubjectInput(){
  this.NameValidation()
}
Id:any
  NameValidation() {

  this.getCode();
  this.SubjectNamecount();

  if(!this.EditedForm){
    if(this.Addform.controls['Subject_Name'].value!='' && this.Addform.controls['Subject_Name'].value!=null)
    {
      if(this.translate){
      this.Disbletranslation=false;
      this.translate=false;
      this.bracketscheckbox=false;
      this.subjectById.Show_English_Name_Ind='N';
      this.Addform.controls['Translated_Subject_Name'].setValue(null);
      }
    }
  }
  var Name = this.Addform.controls['Subject_Name'].value;

  if (Name != '' && Name != undefined && Name !=null) {
    if(this.EditedForm){
     this.Id=this.subjectById.Parent_Subject_Id
    }
    if(!this.EditedForm){
      this.Id=this.subjectById.Subject_Id
    }
    this.ser.getDuplicateNameValidation({
      'ID': this.Id,
      'Name': Name,
      'ScreenName':'SUBJECT BREAKDOWN'
    }).subscribe((i: any) => {
      this.SubjectExistsInd = i;

      this.checkboxvalidate();
      this.Editformvalidation();
      if(this.EditedForm){
        this.subjectnamechange=true;
        }
      if (this.SubjectExistsInd.status) {
          this.namevalidate=false;
          this.subjectnamechange=false;
      }
      else {
        this.subjectnamechange=false;
        if(this.subjectById.Subject_Name!=this.Addform.controls['Subject_Name'].value){
        this.namevalidate = true;}

      }

  }, (error:any) => { console.log(error) }
  );
    if(this.subjectnamechange){
       if(this.EditedForm){
        this.Disbletranslation=false;
      }
    }
  }
  else{
    if(this.namevalidate){
      this.namevalidate=false;
    }
  }


      if(this.translate){
    if(this.EditedForm){
    if(this.subjectById.Language_Ind=='N'){
      if(!this.Disbletranslation){
      this.translatesubjectname();
      }
    }
  }
  }

  }

  ResourceCancel1(data: boolean) {
    this.ResourceCancel();
  }
  closeAddEditElement(value:any)
  {
    if(value){
      this.getsubjectDataRefresh.emit(this.Refresh);
    }
    this.reset();
  }

   _submitted: boolean=false;
  AddSubjectResponse: any;
  Add() {
    this._submitted = true;
    if (this.Addform.valid) {
      if (!this.EditedForm) {
        this.InsertSubject = this.Addform.value;
        this.InsertSubject.Display_Order = 0;
        this.InsertSubject.Subject_Level_Type_Code = this.subjectById.Subject_Level_Type_Code;
        this.InsertSubject.Parent_Subject_Id = this.subjectById.Subject_Id;
        this.InsertSubject.Language_Type_Code=this.appserv.MotherTongueLanguage;
        this.InsertSubject.Subject_Short_Code=this.MajorTopic[0].Subject_Short_Code;

        if(this.subjectById.Show_English_Name_Ind==null){
        this.InsertSubject.Show_English_Name_Ind='N';
        }
        else{
          this.InsertSubject.Show_English_Name_Ind=this.subjectById.Show_English_Name_Ind;
        }
        this.InsertSubject.Retranslate_Ind='N';
        if(this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].value==null){
          this.InsertSubject.Translated_Subject_Subject_Status_Type_Code=this.subjectcode[0].Subject_Status_Type_Code;
        }
      }
      else {
        this.InsertSubject = this.Addform.value;
        this.InsertSubject.Display_Order = this.subjectById.Display_Order;
        this.InsertSubject.Subject_Level_Type_Code = this.subjectById.Subject_Level_Type_Code;
        this.InsertSubject.Parent_Subject_Id = this.subjectById.Parent_Subject_Id;
        this.InsertSubject.Subject_Id = this.subjectById.Subject_Id;
        this.InsertSubject.Subject_Short_Code=this.MajorTopic[0].Subject_Short_Code;
        this.InsertSubject.Language_Type_Code=this.appserv.MotherTongueLanguage;
        if(this.subjectById.Show_English_Name_Ind==null){
        this.InsertSubject.Show_English_Name_Ind='N';
        }
        else{
          this.InsertSubject.Show_English_Name_Ind=this.subjectById.Show_English_Name_Ind;
        }
        this.InsertSubject.Retranslate_Ind='N';
        if(this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].value==null){
          this.InsertSubject.Translated_Subject_Subject_Status_Type_Code=this.subjectcode[0].Subject_Status_Type_Code;
        }
      }
      this.ser.CreateOrModifySubject(this.InsertSubject).subscribe((i: any) => {
        this.AddSubjectResponse = i;
        if (this.AddSubjectResponse.Message == "Success") {
          this.toastr.success('Saved Successfully', 'Success',{timeOut: 500});
          this.Reload = true;

          this.getsubjectDataRefresh.emit(this.Refresh);
          this.reversename=false;
          this.pageload();
        }
        else {
          this.toastr.error(this.AddSubjectResponse.Message);
          this._submitted = false;
        }

      // }).catch((e: any) => {
      //   this.AddSubjectResponse = null;
      //   this._submitted = false;
      // }
      // )
    }, (error:any) => {
        this.AddSubjectResponse = null;
        this._submitted = false;
      console.log(error)
     }
    );
    }

    if(this.Conformationpopupflag){
    this.Conformationpopup();
    }
    if(this.closepopupflag){
    this.Closepopup();
    }
  }

  pageload() {
    this._submitted = false;
    let data = { ID: this.AddSubjectResponse.Value, Reload: this.Reload };
    this.getsubjectId.emit(data);
    if (this.EditedForm){
      this.getBreadcrumbDetails(this.AddSubjectResponse.Value);
    }
    this.reset1.emit();
  }


  getBreadcrumbDetails(data: any) {
    this.ser.getBreadcrumbDetails({ 'ID': data }).subscribe((i: any) => {
      this.Breadcrumblist = i;

    // }).catch((e: any) => {
    //   this.subjectById = null;
    // }
    // )
  }, (error:any) => { console.log(error) }
  );
  }

  cancleorderchange() {
    this.IsOrderByEnabled = false;
    this.SDOInput = null;
  }

  ResourceAssignID: Number;
  ResourceAssign() {
    this.ResourceAssignEnabled = true;
    this.ResourceAssignID = this.subjectById.Subject_Id;
  }

  ResourceCancel() {
    this.ResourceAssignEnabled = false;
    if(this.resourceclosepopupflag){
    this.ResourceClosepopup();
    }

  }

  ResourcePopup(data:any){
    if(this.resourceclosepopupflag){
   this.ResourceClosepopup();
    }
  }

  EditResourceflag:boolean;
  ResourceAssignform:FormGroup;
  DisableButton(data:any){
    this.EditResourceflag=data.EditResourceflag;
    this.ResourceAssignform=data.ResourceAssignform.valid;
  }


  // closeAddEditElement(value:any)
  // {
  //   this.reset();
  // }

  reset() {
    if(this.closepopupflag)
    {
    this.Closepopup();
    }
    this._submitted = false;
    this.translate=false;
    this.reversename=false;
    this.Disbletranslation=false;
    this.subjecttranslationbrackets=false;
    this.bracketscheckbox=false;
    this.namevalidate=false;
    this.subjectById.Show_English_Name_Ind='N';
    this.reset1.emit();
  }

   IsOrderByEnabled: boolean = false;
  SDOInput: any;
  changeDisplayOrder() {
    if (Number(this.subjectById.Parent_Subject_Id) > 0) {
      this.IsOrderByEnabled = true;
      this.SDOInput = {
        Parent_Subject_Id: Number(this.subjectById.Parent_Subject_Id),
        Refresh: this.Refresh,
        IsOrderByEnabled: true
      };
    }
  }

  cancelSubjectOrderChange(value: boolean): any {
    if (value == true) {
      this.IsOrderByEnabled = false;
      this.subjectParentEnable = false;
      this.SDOInput = null;
    }
  }



  onSubjectOrderChangeSucces(value: boolean): any {
    if (value == true) {
      this.Reload = true;

      this.Refresh.dataID = Number(this.SDOInput.Parent_Subject_Id);
      this.getsubjectDataRefresh.emit(this.Refresh);
    }
  }

  subjectParentEnable: boolean = false;
  SubjectParentInput: any;
  onSubjectParentChange() {
    if (Number(this.subjectById.Parent_Subject_Id) > 0 && Number(this.subjectById.Subject_Id) > 0) {
      this.subjectParentEnable = true;
      this.SubjectParentInput = {
        Subject_Id: this.subjectById.Subject_Id,
        Parent_Subject_Id: Number(0),
        Selected_Header_ID: Number(0),
        Refresh: this.Refresh,
        subjectParentEnable: true
      };
    }
  }

  cancelSubjectParentChange(value: boolean): any {
    if (value == true) {
      this.subjectParentEnable = false;
    }
  }

  SubjectParentChange(){
    this.cancelSubjectParentChange(true);
  }

  onSubjectParentChangeSucces(value: boolean): any {
    if (value == true) {
      this.Reload = true;
      this.Refresh.dataID = Number(this.SubjectParentInput.Selected_Header_ID);
      this.getsubjectDataRefresh.emit(this.Refresh);

    }

  }

  value:any;
  translation:any;
  translatesubjectname()
  {
    // key:'AIzaSyDN0bRBVfvHsCIt8sT3H_nwtlkdVn1kBSA',
    const googleObj: GoogleObj = {

      q:this.Addform.controls['Subject_Name'].value,
      source:'en',
      target: '',
      format:'text'
      };
      this.google.translate(googleObj).subscribe(
        (res: any) => {
          this.translation=res;
          this.value=this.translation.data.translations[0].translatedText;
          this.Addform.controls['Translated_Subject_Name'].setValue(this.value);
          if(this.subjectById.Show_English_Name_Ind=='Y'){
            var Tranletedname=this.Addform.controls['Translated_Subject_Name'].value;
            var subjectname=this.Addform.controls['Subject_Name'].value;
            if(Tranletedname!=null&&subjectname!=null){
              this.Addform.controls['Translated_Subject_Name'].setValue(Tranletedname+' '+'('+subjectname+')')
              }
              this.bracketscheckbox=true;
          }
          if(!this.translate){
            this.Addform.controls['Translated_Subject_Name'].setValue(null);
          }
          this.Translationcount();
          this.Descriptioncount();

        },
        err => {
        console.log(err);
        }
        );
        this.subjectnamechange=false;
        this.translate=true;
        this.Disbletranslation=true;
        if(this.translate){
          if(this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].value==null){
            this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].setValue(this.subjectcode[0].Subject_Status_Type_Code);
          }
        }
        if(!this.EditedForm){
          this.Disbletranslation=true;
          this.subjecttranslationbrackets=true;
        }
        this.Translationcount();
        this.Descriptioncount();
      }

   translate: boolean=false;
  Translatecheckbox() {
    this.translate=!this.translate;
    if(this.translate){
      this.subjectnamechange=false;
      this._submitted = true;
      this.subjecttranslationbrackets=true;
      if(this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].value==null){
        this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].setValue(this.subjectcode[0].Subject_Status_Type_Code);
      }
      if (this.Addform.valid) {
        this.translatesubjectname();
      }
    }
    else
    {
      this.ngSelect1=null;
      this.Addform.controls['Translated_Subject_Name'].setValue(null);
      this.Addform.controls['Translated_Subject_Subject_Status_Type_Code'].setValue(null);

      this.bracketscheckbox=false;
      this.subjectById.Show_English_Name_Ind='N';


    }
  }

  Bracketscheckbox(){
    this.bracketscheckbox=!this.bracketscheckbox;
    var Tranletedname=this.Addform.controls['Translated_Subject_Name'].value;
    var subjectname=this.Addform.controls['Subject_Name'].value;
    if(this.bracketscheckbox){
      if(this.Addform.controls['Subject_Name'].value!='' && this.Addform.controls['Subject_Name'].value!=null)
      {
      if(Tranletedname!=null&&subjectname!=null){
      this.Addform.controls['Translated_Subject_Name'].setValue(Tranletedname+' '+'('+subjectname+')')
      }
    }
    this.subjectById.Show_English_Name_Ind='Y';

    }
    else{
      if(this.Addform.controls['Translated_Subject_Name'].value!='' && this.Addform.controls['Translated_Subject_Name'].value!=null)
      {
      this.translatesubjectname();
      }
      this.subjectById.Show_English_Name_Ind='N';
    }

  }

  Conformationpopupflag:boolean;
  Conformationpopup(){
    this.Conformationpopupflag=!this.Conformationpopupflag;
  }

  closepopupflag:boolean=false;
  Closepopup(){
    this.closepopupflag=!this.closepopupflag;
  }

  resourceclosepopupflag:boolean;
  ResourceClosepopup(){
    this.resourceclosepopupflag=!this.resourceclosepopupflag;
  }

  getcodes:any;
  getCode()
  {
    this.ser.GetCode({'Tablename':"LANGUAGE_TYPE"}).subscribe((i:any)=>{
      this.getcodes=i;
      for (let item of this.getcodes) {
        if (item.Code==this.appserv.MotherTongueLanguage) {
          this.getcodedescription=item.Description;
        }
      }

    // }).catch((e:any)=>{
    //   this.getcodes=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  subjectvaluelength:any;
  subjectMaxlength:any;
  SubjectNamecount()
  {
    this.subjectMaxlength=100;
    if(this.Addform.controls.Subject_Name.value!=''&&this.Addform.controls.Subject_Name.value!=null){
    if(this.Addform.controls.Subject_Name.value.length>0){
        this.subjectvaluelength =this.Addform.controls.Subject_Name.value.length;
    }
    else{
      this.subjectvaluelength=0;
    }
}
  else{
    this.subjectvaluelength=0;
  }
 }


 Descriptionvaluelength:any;
 DescriptionMaxlength:any;
 Descriptioncount()
 {
  this.DescriptionMaxlength=4000;
  if(this.Addform.controls.Description_text.value!=''&&this.Addform.controls.Description_text.value!=null){
    if(this.Addform.controls.Description_text.value.length>0){
        this.Descriptionvaluelength =this.Addform.controls.Description_text.value.length;
    }
    else{
      this.Descriptionvaluelength=0;
    }
  }
  else{
    this.Descriptionvaluelength=0;

  }
 }

 Translationvaluelength:any;
 TranslationMaxlength:any;
 Translationcount()
 {
  this.TranslationMaxlength=250;
  if(this.Addform.controls.Translated_Subject_Name.value!=''&&this.Addform.controls.Translated_Subject_Name.value!=null){
    if(this.Addform.controls.Translated_Subject_Name.value.length>0){
      this.Translationvaluelength =this.Addform.controls.Translated_Subject_Name.value.length;
  }
  else{
    this.Translationvaluelength=0;
  }
  }
  else{
    this.Translationvaluelength=0;
  }

 }

 Saveflag:boolean;
  save(){
    this.Addresource.emit(this.Saveflag);
  }



}

